module.exports = __webpack_public_path__ + "img/download_logo.0fae8f4c.png";